export default __webpack_public_path__ + "static/media/image-mark-shuttleworth.fc30f35b.png";